import React, { ChangeEvent } from 'react'
import { ConsentText } from '@mobi/account/Areas/SignUp/Components/Verification/ConsentText'
import { Checkbox } from '@mobi/component-library/Common/V2'

type Props = { isBusy: boolean; onChange: (e: ChangeEvent<HTMLInputElement>) => void }
export const DocumentPermission = ({ isBusy, onChange }: Props) => {
  return (
    <Checkbox
      name='ConsentText'
      label={ConsentText}
      isDisabled={isBusy}
      onChange={e => onChange(e)}
    />
  )
}
